import React from "react";
import Captcha from "./Captcha";

const CaptchaInput = ({ value, onChange, onCaptchaChange }) => {
  return (
    <>
      <Captcha onChange={onCaptchaChange} />
      <div className="form-group floating position-relative">
        <input
          type="text"
          className="form-control floating input"
          name="captchaInput"
          value={value}
          onChange={onChange}
        />
        <label htmlFor="usr">Enter The Code</label>
        <div className="input_icon">
          <img src="./images/code.png" alt="Captcha" />
        </div>
      </div>
    </>
  );
};

export default CaptchaInput; 